import type { Translations } from 'ckeditor5'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import de from 'ckeditor5/translations/de.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import en from 'ckeditor5/translations/en.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import es from 'ckeditor5/translations/es.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import fr from 'ckeditor5/translations/fr.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import it from 'ckeditor5/translations/it.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import ja from 'ckeditor5/translations/ja.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import nb from 'ckeditor5/translations/nb.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import pl from 'ckeditor5/translations/pl.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import pt from 'ckeditor5/translations/pt.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import th from 'ckeditor5/translations/th.js'
// @ts-expect-error: Translation files are not typed in the ckeditor5 package.
import zh from 'ckeditor5/translations/zh.js'

import { add } from 'ckeditor5'

const editorLocaleMap: Record<string, string> = {
  en: 'en',
  'en-CA': 'en',
  'fr-CA': 'fr',
  'fr-FR': 'fr',
  es: 'es',
  'es-ES': 'es',
  'es-LA': 'es',
  'en-AE': 'en',
  'en-AU': 'en',
  'en-GB': 'en',
  'en-SG': 'en',
  'it-IT': 'it',
  'nb-NO': 'nb',
  'th-TH': 'th',
  'ja-JP': 'ja',
  'pt-BR': 'pt',
  'pt-PT': 'pt',
  'is-IS': 'en',
  'de-DE': 'de',
  'zh-SG': 'zh',
  'zh-TW': 'zh',
  'pl-PL': 'pl',
}

const editorTranslations: Record<string, Translations> = {
  en,
  fr,
  es,
  de,
  it,
  ja,
  nb,
  pl,
  pt,
  th,
  zh,
}

add('en', {
  Cut: 'Cut',
  Paste: 'Paste',
  PasteAsText: 'Paste as Text',
})
add('fr', {
  Cut: 'Couper',
  Paste: 'Coller',
  PasteAsText: 'Coller comme texte',
})
add('ja', {
  Cut: 'カット',
  Paste: '貼り付け',
  PasteAsText: 'テキストとして貼り付け',
})
add('es', {
  Cut: 'Cortar',
  Paste: 'Pegar',
  PasteAsText: 'Pegar como texto',
})
add('de', {
  Cut: 'Ausschneiden',
  Paste: 'Einfügen',
  PasteAsText: 'Als Text einfügen',
})
add('pt', {
  Cut: 'Recortar',
  Paste: 'Colar',
  PasteAsText: 'Colar como texto',
})
add('zh', {
  Cut: '剪切',
  Paste: '粘贴',
  PasteAsText: '以文本形式粘贴',
})
add('th', {
  Cut: 'ตัด',
  Paste: 'วาง',
  PasteAsText: 'วางในรูปแบบข้อความ',
})
add('pl', {
  Cut: 'Wytnij',
  Paste: 'Wklej',
  PasteAsText: 'Wklej jako tekst',
})

export const getValidEditorLocale = (locale: string) => {
  return editorLocaleMap[locale] || 'en'
}

export const getEditorTranslation = (locale: string) => {
  const editorLocale = getValidEditorLocale(locale)
  return editorTranslations[editorLocale] || en
}
